import { useId, useState } from "react";
import { H2, Label, RadioGroup, SizableText, Text, View } from "tamagui";
import { Card } from "./components/radioParts.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
const data = [{
  id: "vd-with-desc-paypal",
  label: "PayPal",
  description: "You will be redirected to the PayPal website"
}, {
  id: "vd-with-desc-mastercard",
  label: "Mastercard",
  description: "Mastercard secure code is a private code for you"
}, {
  id: "vd-with-desc-visa",
  label: "Visa",
  description: "This is a secure 128-bit SSL encrypted payment"
}];
function VerticalWithDescription() {
  const [value, setValue] = useState("vd-visa");
  const uniqueId = useId();
  return /* @__PURE__ */jsx(View, {
    width: "100%",
    items: "center",
    children: /* @__PURE__ */jsxs(View, {
      flexDirection: "column",
      minW: "100%",
      "$group-window-gtSm": {
        maxW: 400,
        minW: 400
      },
      gap: "$4",
      children: [/* @__PURE__ */jsxs(View, {
        flexDirection: "column",
        gap: "$2",
        children: [/* @__PURE__ */jsx(H2, {
          children: "Payment"
        }), /* @__PURE__ */jsx(Text, {
          fontWeight: "300",
          color: "$color9",
          children: "Select your payment method"
        })]
      }), /* @__PURE__ */jsx(RadioGroup, {
        shrink: 1,
        value,
        onValueChange: setValue,
        children: /* @__PURE__ */jsx(View, {
          flexDirection: "column",
          shrink: 1,
          flexWrap: "wrap",
          gap: "$2",
          children: data.map(({
            id,
            label,
            description
          }) => /* @__PURE__ */jsx(Item, {
            selected: value === id,
            uniqueId,
            setValue,
            description,
            id,
            label
          }, id))
        })
      })]
    })
  });
}
const Item = ({
  id,
  label,
  description,
  setValue,
  uniqueId,
  selected
}) => {
  return /* @__PURE__ */jsxs(Card, {
    flexDirection: "row",
    shrink: 1,
    items: "flex-start",
    gap: "$3",
    p: "$3",
    active: selected,
    onPress: () => setValue(id),
    cursor: "pointer",
    children: [/* @__PURE__ */jsx(View, {
      onPress: e => e.stopPropagation(),
      children: /* @__PURE__ */jsx(RadioGroup.Item, {
        id: uniqueId + id,
        value: id,
        children: /* @__PURE__ */jsx(RadioGroup.Indicator, {})
      })
    }), /* @__PURE__ */jsxs(View, {
      flexDirection: "column",
      shrink: 1,
      children: [/* @__PURE__ */jsx(Label, {
        size: "$4",
        lineHeight: "$2",
        items: "flex-start",
        flexDirection: "column",
        htmlFor: uniqueId + id,
        cursor: "pointer",
        children: label
      }), /* @__PURE__ */jsx(SizableText, {
        shrink: 1,
        size: "$3",
        fontWeight: "300",
        color: "$color9",
        children: description
      })]
    })]
  });
};
VerticalWithDescription.fileName = "VerticalWithDescription";
function VerticalRadioGroupWithDescriptionControlled(props) {
  const uniqueId = useId();
  const onValueChange = value => {
    props.onChange(value);
  };
  return /* @__PURE__ */jsxs(View, {
    flexDirection: "column",
    minW: "100%",
    "$group-window-gtSm": {
      maxW: 400,
      minW: 400
    },
    gap: "$4",
    children: [props.title || props.label ? /* @__PURE__ */jsxs(View, {
      flexDirection: "column",
      gap: "$2",
      children: [props.title ? /* @__PURE__ */jsx(H2, {
        children: props.title
      }) : null, props.label ? /* @__PURE__ */jsx(Text, {
        fontWeight: "300",
        fos: "15px",
        children: props.label
      }) : null]
    }) : null, /* @__PURE__ */jsx(RadioGroup, {
      flexShrink: 1,
      value: props.value,
      onValueChange,
      children: /* @__PURE__ */jsx(View, {
        flexDirection: "column",
        flexShrink: 1,
        flexWrap: "wrap",
        gap: "$2",
        children: props.items.map(({
          value,
          label,
          description
        }) => /* @__PURE__ */jsxs(Card, {
          flexDirection: "row",
          flexShrink: 1,
          items: "flex-start",
          gap: "$3",
          p: "$3",
          cursor: "pointer",
          active: props.value === value,
          onPress: () => onValueChange(value),
          style: props.error ? {
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "rgb(255, 107, 107)"
          } : void 0,
          children: [/* @__PURE__ */jsx(View, {
            onPress: e => e.stopPropagation(),
            children: /* @__PURE__ */jsx(RadioGroup.Item, {
              id: uniqueId + value,
              value,
              children: /* @__PURE__ */jsx(RadioGroup.Indicator, {})
            })
          }), /* @__PURE__ */jsxs(View, {
            flexDirection: "column",
            flexShrink: 1,
            children: [/* @__PURE__ */jsx(Label, {
              size: "$4",
              lineHeight: "$2",
              alignItems: "flex-start",
              flexDirection: "column",
              cursor: "pointer",
              htmlFor: uniqueId + value,
              children: label
            }), description ? /* @__PURE__ */jsx(SizableText, {
              size: "$3",
              fontWeight: "300",
              color: "rgba(92, 92, 92, 1)",
              children: description
            }) : null]
          })]
        }, uniqueId + value))
      })
    })]
  });
}
export { VerticalRadioGroupWithDescriptionControlled, VerticalWithDescription };
//# sourceMappingURL=VerticalWithDescription.mjs.map
